import { render } from "./Launch.vue?vue&type=template&id=5a51448c&scoped=true"
import script from "./Launch.vue?vue&type=script&lang=js"
export * from "./Launch.vue?vue&type=script&lang=js"

import "./Launch.vue?vue&type=style&index=0&id=5a51448c&scoped=true&lang=css"

import exportComponent from "D:\\Partheas\\Projects\\VDAB\\Code\\qpp-kiosk\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a51448c"]])

export default __exports__